import { Component } from '@theme/component';
import { WishlistStorage } from './wishlist-storage.js';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element for toggling wishlist state on product cards and product page.
 *
 * @extends {Component}
 */
class WishlistButton extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#updateState();
    this.addEventListener('click', this.#handleClick);
    document.addEventListener(ThemeEvents.wishlistUpdate, this.#onWishlistUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
    document.removeEventListener(ThemeEvents.wishlistUpdate, this.#onWishlistUpdate);
  }

  #onWishlistUpdate = () => {
    this.#updateState();
  };

  #handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const productId = this.dataset.productId;
    const handle = this.dataset.productHandle;
    const title = this.dataset.productTitle || '';
    const image = this.dataset.productImage || '';
    const price = this.dataset.productPrice || '';
    const url = this.dataset.productUrl || '';
    const variantId = this.dataset.variantId || '';

    if (!productId || !handle) return;

    WishlistStorage.toggle({
      id: productId,
      handle,
      title,
      image,
      price,
      url,
      variantId,
    });
    this.#updateState();
  };

  #updateState() {
    const productId = this.dataset.productId;
    if (!productId) return;

    const inWishlist = WishlistStorage.has(productId);
    const btn = this.querySelector('button');
    const outline = this.querySelector('.svg-wrapper--outline');
    const filled = this.querySelector('.svg-wrapper--filled');

    if (btn) {
      btn.setAttribute('aria-label', inWishlist ? this.dataset.labelRemove || 'Remove from wishlist' : this.dataset.labelAdd || 'Add to wishlist');
      btn.setAttribute('aria-pressed', String(inWishlist));
    }
    if (outline) outline.classList.toggle('hidden', inWishlist);
    if (filled) filled.classList.toggle('hidden', !inWishlist);
    this.setAttribute('data-in-wishlist', String(inWishlist));
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}
